import { RouterProvider } from 'react-router-dom';

// project imports
import { QueryClientProvider } from '@tanstack/react-query';
import queryClient from './queryClient';
import router from 'routes';
import ThemeCustomization from 'themes';

import ScrollTop from 'components/ScrollTop';

// ==============================|| APP - THEME, ROUTER, LOCAL ||============================== //

export default function App() {
  return (
    <ThemeCustomization>
      <QueryClientProvider client={queryClient}>
          <ScrollTop>
            <RouterProvider router={router} />
          </ScrollTop>
      </QueryClientProvider>
    </ThemeCustomization>
  );
}
